import axios from "axios";

export const GET_FORMATIONS = "GET_FORMATIONS";
export const DELETE_FORMATION = "DELETE_FORMATION";
export const SET_CURRENT_FORMATION = "SET_CURRENT_FORMATION";

const API = `${process.env.REACT_APP_API_URL}/api/formations`;

// Liste complète (brouillons inclus) pour l'admin/référent
export const getFormationsAdmin = () => async (dispatch) => {
  try {
    const res = await axios.get(`${API}/admin`, { withCredentials: true });
    dispatch({ type: GET_FORMATIONS, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

// Génération IA. params: { topic, level, categoryId, modulesCount, sourceType, sourceContent, sourceUrl }
// 202 => plan et structure créés, leçons/quizz rédigés en arrière-plan (le builder
// suit l'avancement via formation.generationStatus) ; 207 => génération partielle.
export const generateFormation = (params) => async (dispatch) => {
  const res = await axios({
    method: "post",
    url: `${API}/generate`,
    withCredentials: true,
    data: params,
  });
  const formation = res.data && res.data.formation ? res.data.formation : res.data;
  dispatch({ type: SET_CURRENT_FORMATION, payload: formation });
  return {
    formation,
    generating: res.status === 202,
    partial: res.status === 207,
    message: res.data && res.data.message ? res.data.message : null,
    // Avertissement non bloquant (ex : support Genially/pptx trop pauvre en texte)
    warning: res.data && res.data.warning ? res.data.warning : null,
  };
};

// Extraction du texte d'un PowerPoint (.pptx). Renvoie { content, meta } ;
// le contenu est ensuite envoyé tel quel à /generate avec sourceType "pptx".
export const extractPptxSource = (file) => async () => {
  const data = new FormData();
  data.append("media", file);
  const res = await axios.post(`${API}/extract-pptx`, data, { withCredentials: true });
  return res.data;
};

// Transcription de vidéos Loom (une URL de partage par ligne). Renvoie { content, meta } ;
// le contenu est ensuite envoyé à /generate avec sourceType "loom".
export const extractLoomSource = (urls) => async () => {
  const res = await axios.post(`${API}/extract-loom`, { urls }, { withCredentials: true });
  return res.data;
};

export const deleteFormation = (id) => async (dispatch) => {
  await axios({ method: "delete", url: `${API}/${id}`, withCredentials: true });
  dispatch({ type: DELETE_FORMATION, payload: { id } });
};

export const publishFormation = (id) => async () => {
  const res = await axios({ method: "post", url: `${API}/${id}/publish`, withCredentials: true });
  return res.data;
};

export const unpublishFormation = (id) => async () => {
  const res = await axios({ method: "post", url: `${API}/${id}/unpublish`, withCredentials: true });
  return res.data;
};

const ROOT = `${process.env.REACT_APP_API_URL}/api`;

// Détail complet (édition)
export const getFormation = (id) => async (dispatch) => {
  const res = await axios.get(`${API}/${id}`, { withCredentials: true });
  dispatch({ type: SET_CURRENT_FORMATION, payload: res.data });
  return res.data;
};

export const updateFormation = (id, fields) => async () =>
  (await axios({ method: "put", url: `${API}/${id}`, withCredentials: true, data: fields })).data;

// Modules
export const createModule = (formationId, title) => async () =>
  (await axios({ method: "post", url: `${API}/${formationId}/modules`, withCredentials: true, data: { title } })).data;
export const updateModule = (moduleId, fields) => async () =>
  (await axios({ method: "put", url: `${ROOT}/modules/${moduleId}`, withCredentials: true, data: fields })).data;
export const deleteModule = (moduleId) => async () =>
  (await axios({ method: "delete", url: `${ROOT}/modules/${moduleId}`, withCredentials: true })).data;
export const publishModuleVersion = (moduleId) => async () =>
  (await axios({ method: "post", url: `${ROOT}/modules/${moduleId}/publish-version`, withCredentials: true })).data;

// Leçons
export const createLesson = (moduleId, payload) => async () =>
  (await axios({ method: "post", url: `${ROOT}/modules/${moduleId}/lessons`, withCredentials: true, data: payload })).data;
export const updateLesson = (lessonId, fields) => async () =>
  (await axios({ method: "put", url: `${ROOT}/lessons/${lessonId}`, withCredentials: true, data: fields })).data;
export const deleteLesson = (lessonId) => async () =>
  (await axios({ method: "delete", url: `${ROOT}/lessons/${lessonId}`, withCredentials: true })).data;

// Questions
export const createQuestion = (quizId, payload) => async () =>
  (await axios({ method: "post", url: `${ROOT}/quizzes/${quizId}/questions`, withCredentials: true, data: payload })).data;
export const updateQuestion = (questionId, fields) => async () =>
  (await axios({ method: "put", url: `${ROOT}/questions/${questionId}`, withCredentials: true, data: fields })).data;
export const deleteQuestion = (questionId) => async () =>
  (await axios({ method: "delete", url: `${ROOT}/questions/${questionId}`, withCredentials: true })).data;

// Régénération ciblée + version finale
export const regeneratePart = (payload) => async () =>
  (await axios({ method: "post", url: `${API}/regenerate`, withCredentials: true, data: payload })).data;
export const publishFinalVersion = (formationId) => async () =>
  (await axios({ method: "post", url: `${API}/${formationId}/publish-final-version`, withCredentials: true })).data;

// Résultats par formation (admin/référent)
export const getFormationResults = (formationId) => async () =>
  (await axios.get(`${API}/${formationId}/results`, { withCredentials: true })).data;

// Statistiques globales + par équipe (admin/référent)
export const getFormationStats = () => async () =>
  (await axios.get(`${API}/stats/overview`, { withCredentials: true })).data;
